import React from 'react'
import ReactMarkdown from 'react-markdown'
import { useTranslation } from 'react-i18next'
import Meta from '../components/Meta'
import termsOfService from '../content/legal/termsOfService'

export default function TermsOfService() {
  const { i18n } = useTranslation()
  const lang = (i18n.language || 'en').split('-')[0]
  const md = termsOfService[lang] || termsOfService.en

  return (
    <div className="prose mx-auto py-8 px-4">
      <Meta titleKey="legal.tos.meta.title" descKey="legal.tos.meta.description" />
      <ReactMarkdown>{md}</ReactMarkdown>
    </div>
  )
}
